import property from 'lodash/property';
export var appVersionSelector = property('app.version');
export var isPageTransitioningSelector = property('app.isPageTransitioning');
export var isUpdateAvailableSelector = property('app.isUpdateAvailable');